import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlightDetailsComponent } from './flight-details.component';
import { SharedModule } from '@shared/modules/shared.module';
import { CrewModule } from './crew/crew.module';
import { ReleaseModule } from './release/release.module';
import { InboundFlightModule } from './inbound-flight/inbound-flight.module';
import { AircraftModule } from './aircraft/aircraft.module';
import { KcmModule } from './kcm/kcm.module';
import { HotelCardComponent } from './hotel-card/hotel-card.component';
import { HotelModule } from '@shared/features/hotel/hotel.module';
import { WeatherModule } from './weather/weather.module';
import { SaveAllDialogComponent } from './save-all-dialog/save-all-dialog.component';
import { ArmedPaxModule } from './armed-pax/armed-pax.module';
import { FlightInfoModule } from './flight-info/flight-info.module';
import { PaxConnectionsComponent } from './pax-connections/pax-connections.component';
import { StandbyListModule } from './standby-list/standby-list.module';

@NgModule({
  declarations: [
    FlightDetailsComponent,
    HotelCardComponent,
    SaveAllDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    CrewModule,
    ReleaseModule,
    InboundFlightModule,
    AircraftModule,
    KcmModule,
    HotelModule,
    WeatherModule,
    ArmedPaxModule,
    FlightInfoModule,
    PaxConnectionsComponent,
    StandbyListModule,
  ],
})
export class FlightDetailsModule {}
